var ResourcesInfographics = function(){

    'use strict';

    var $ = jQuery;    var instances = [];


    function onReady() {
        $('.module.resources-infographics').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id');

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // instance object
        var instance = {
            init: function () {
                // Remove this lines this and the next line
                // console.log('Instance of resources-infographics initialized with id and view: ', id, view);
            }
        };


        $( ".share-button" ).click(function() {
            $(".share-social-networks").slideToggle();
        });

        $( ".share-social-networks a.close" ).click(function() {
            $(".share-social-networks").slideToggle();
        });





        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

ResourcesInfographics();
